import { Component, OnInit } from '@angular/core';
import { Input } from '@angular/core';
import { Output } from '@angular/core';
import { EventEmitter } from '@angular/core';
import { SubscriptionPacketsService } from '../../services/subscription-packets.service';
import { SubscriptionPacketDto } from '../../../../dtos/subscriptionPacketDto';
import { Observable } from 'rxjs';
import { GlobalDataService } from '../../../../shared-services/global-data.service';
import { MonumentsDataService } from '../../data-storage/monuments-data.service';
import { map } from 'rxjs/operators';
import { TranslateService } from '@ngx-translate/core';
import { Router } from '@angular/router';
import { UserDataService } from '../../data-storage/user-data.service';

@Component({
    selector: 'app-site-packets',
    templateUrl: './site-packets.component.html',
    styleUrls: ['./site-packets.component.scss']
})
export class SitePacketsComponent implements OnInit {

    constructor(private subscriptionPacketsService: SubscriptionPacketsService,
                public globalDataService: GlobalDataService,
                private monumentsDataService: MonumentsDataService,
                private router:Router,
                public translate: TranslateService,
                private userDataService: UserDataService) {
    }

    @Input()
    siteId: number;

    @Input()
    isPacketOpen: boolean;

    @Input()
    backDrop: boolean = true;

    @Input()
    inline: boolean = false;

    @Output()
    isPacketOpenChange = new EventEmitter<boolean>();

    $packets: Observable<SubscriptionPacketDto[]>;

    monumentsMetaCheckboxes$:Observable<any>;

    ngOnInit(): void {
        this.$packets = this.subscriptionPacketsService.getSubscriptionPackets(this.siteId);
        this.monumentsMetaCheckboxes$ = this.monumentsDataService.getMonumentBySiteId(this.siteId)
            .pipe(
                map((monuments)=>{
                    return {
                        length: monuments.length,
                        panoramics: monuments.filter((monument)=>monument.componentConfiguration.vr).length,
                        models: monuments.filter((monument)=>monument.componentConfiguration.model).length,
                        info: monuments.filter((monument)=>monument.componentConfiguration.info).length,
                    }
                })
            )
    }

    closePackets(event) {
        if (event.target.className === 'packetBackdrop' || event.target.className === 'closePackets') {
            this.isPacketOpenChange.emit(false);
        }
    }

    goToPacket(packet:string){
        sessionStorage.setItem("packetId",packet);
        this.router.navigate([this.globalDataService.getRemoteContext()+'/'+this.translate.currentLang+'/buy']);
    }

    isLoggedIn(){
        return !!this.userDataService.getUser().id;
    }

}
